<script lang="ts">
	import ShellLayout from "./ShellLayout.svelte";
	import ManageSuggestions from "./ManageSuggestions.svelte";
</script>

<ShellLayout><ManageSuggestions /></ShellLayout>
